import React, { createContext, useContext, useState } from "react";

export function NoticeProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [noticeHeight, setNoticeHeight] = useState<number>(0);

  return (
    <NoticeContext.Provider value={{ noticeHeight, setNoticeHeight }}>
      {children}
    </NoticeContext.Provider>
  );
}

const NoticeContext = createContext<{
  noticeHeight: number;
  setNoticeHeight: React.Dispatch<React.SetStateAction<number>>;
}>({
  noticeHeight: 0,
  setNoticeHeight: () => {},
});

const useNoticeHeight = () => {
  return useContext(NoticeContext);
};

export { NoticeContext, useNoticeHeight };
